import { Component, OnInit } from '@angular/core';
import { FilterService } from 'src/app/services/filter.service';
import { RoleFilters } from '../../models/roleFilters';
import { TimeZoneService} from "../../services/timezone.service";

@Component({
  selector: 'app-course-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})

export class FilterCourseComponent implements OnInit {
  public roleFilters: RoleFilters;
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;

  constructor(
    private _filter: FilterService,
    private timezoneService: TimeZoneService
  ) {
    this._filter.roleFiltersSubject.subscribe(
      (data:RoleFilters) => {
        this.roleFilters=data;
      }
    );
  }

  public updateRoleFilters(event, property:string){
    this._filter.updateFilterValues(property, event.checked);
  }

  ngOnInit() {
    // Check the timeZone
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
  }

}
